import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
    const [totalMonthPrice, setTotalMonthPrice] = useState(() => {
        try {
            const v = localStorage.getItem('totalMonthPrice');
            return v != null ? Number(v) : 0;
        } catch {
            return 0;
        }
    });
    const [orderTimeSettings, setOrderTimeSettings] = useState(() => {
        try {
            const v = localStorage.getItem('orderTimeSettings');
            return v ? JSON.parse(v) : null;
        } catch {
            return null;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem('totalMonthPrice', String(totalMonthPrice ?? 0));
        } catch {}
    }, [totalMonthPrice]);

    useEffect(() => {
        try {
            if (orderTimeSettings) {
                localStorage.setItem('orderTimeSettings', JSON.stringify(orderTimeSettings));
            } else {
                localStorage.removeItem('orderTimeSettings');
            }
        } catch {}
    }, [orderTimeSettings]);

    const value = useMemo(() => ({
        totalMonthPrice,
        orderTimeSettings,
        setTotalMonthPrice,
        setOrderTimeSettings,
    }), [totalMonthPrice, orderTimeSettings]);

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => {
    const ctx = useContext(AppContext);
    if (!ctx) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return ctx;
};


